<template>
    <div class="choose-bazis-section" id="why-choose-bazis-a">
        <div class="container">
            <div class="choose-title">
                <h2>{{ aboutPage.why_bazis_title }}</h2>
                <div class="desc"><p v-html="aboutPage.why_bazis_title_desc"></p></div>
                <div class="desc-red"><p v-html="aboutPage.why_bazis_red_desc"></p></div>
            </div>
            <div class="choose-items">
                <div class="item">
                    <h3 v-if="isMobileChecker">{{ aboutPage.why_bazis_awards.title }}</h3>
                    <div class="item-img" :style="'background-image: url(' + aboutPage.why_bazis_awards.img + ')'"></div>
                    <div class="item-desc">
                        <h3 v-if="!isMobileChecker">{{ aboutPage.why_bazis_awards.title }}</h3>
                        <p v-html="aboutPage.why_bazis_awards.desc"></p>
                        <router-link to="/awards">
                            <span>{{ aboutPage.why_bazis_awards.btn }}</span>
                            <svgIcon name="arrow-go-right"/>
                        </router-link>
                    </div>
                </div>
                <div class="item">
                    <h3 v-if="isMobileChecker">{{ aboutPage.why_bazis_quality.title }}</h3>
                    <div class="item-img" :style="'background-image: url(' + aboutPage.why_bazis_quality.img + ')'"></div>
                    <div class="item-desc">
                        <h3 v-if="!isMobileChecker">{{ aboutPage.why_bazis_quality.title }}</h3>
                        <p v-html="aboutPage.why_bazis_quality.desc"></p>
                        <router-link to="/quality">
                            <span>{{ aboutPage.why_bazis_quality.btn }}</span>
                            <svgIcon name="arrow-go-right"/>
                        </router-link>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import {mapGetters} from 'vuex'
    import svgIcon from '@/components/partials/SvgIcon.vue';
    export default {
        name: 'choose-bazis-section',
        components: {
            svgIcon,
        },
        data () {
            return {
            }
        },
        computed: mapGetters({
            aboutPage: 'loadAboutPage',
            isMobileChecker: 'loadIsMobileChecker',
        }),
        methods: {
        },
        created () {
        },
        mounted() {
        }
    }
</script>

<style lang="scss">
    @import '@/styles/components/about/choose-bazis-section.scss';
    @import '@/styles/components/about/respond/choose-bazis-section-respond.scss';
</style>